<template>
  <div>
    <div v-if="operasiCeklis">
      <div class="d-flex flex-between my-3">
        <h4 class="text-uppercase mb-0">Ceklis Keselamatan Operasi</h4>
        <router-link
          :to="
            `/operasi/form-ceklis/${$route.params.id_ralan}/${$route.params.id}?fromTab=4`
          "
          class="btn btn-with-icon-left btn-primary text-uppercase"
        >
          <i class="material-symbols-outlined">create</i>
          Ubah Ceklis Keselamatan
        </router-link>
      </div>
      <div class="row mb-2 mt-4">
        <div class="col-md-12">
          <FormRow
            v-for="row in upperForm"
            v-bind:key="row.colnum + String(Math.random(1023))"
            :row="row"
            @handleChange="(e) => handleChange(e)"
          />
        </div>
      </div>
      <hr />
      <div class="row mb-5">
        <div class="col-md-4">
          <FormRow
            v-for="row in leftForm"
            v-bind:key="row.colnum + String(Math.random(1023))"
            :row="row"
            @handleChange="(e) => handleChange(e)"
          />
        </div>
        <div class="col-md-4 pl-0">
          <FormRow
            v-for="row in middleForm"
            v-bind:key="row.colnum + String(Math.random(1023))"
            :row="row"
            @handleChange="(e) => handleChange(e)"
          />
        </div>
        <div class="col-md-4 pl-0">
          <FormRow
            v-for="row in rightForm"
            v-bind:key="row.colnum + String(Math.random(1023))"
            :row="row"
            @handleChange="(e) => handleChange(e)"
          />
        </div>
      </div>
    </div>
    <EmptyState v-else :data="empty" />
  </div>
</template>

<script>
// @ is an alias to /src
import FormRow from "@/components/FormRow.vue";
import { getFullUrl } from "@/data/helper.js";
// import { HTTP } from "@/config.js";
import {
  upperFormCeklis,
  leftFormCeklis,
  middleFormCeklis,
  rightFormCeklis,
} from "@/data/OperasiDetail.js";
import { dataCeklis } from "@/data/OperasiForm.js";
import EmptyState from "@/components/EmptyState.vue";
export default {
  props: { ralan: Object, operasi: Object },
  name: "OperasiFormCeklis",
  components: {
    EmptyState,
    FormRow,
  },
  data: () => {
    return {
      empty: {
        img: "/img/nurse.svg",
        title: "Belum ada ceklis keselamatan operasi",
        content:
          "Isi data ceklis keselamatan operasi dengan mengeklik tombol di bawah ini",
        size: "small",
        link: "/operasi/form-ceklis/",
        label: "input ceklis keselamatan operasi",
      },
      data: dataCeklis,
      detailTop: null,
      upperForm: upperFormCeklis,
      leftForm: leftFormCeklis,
      middleForm: middleFormCeklis,
      rightForm: rightFormCeklis,
      operasiCeklis: null,
      introRalanOperasi: { introRalan: {}, introOperasi: [] },
      steps: [],
      id_ceklis: null,
      formSet: {
        id_operasi: null,
        id_petugas: null,
        sign_in: "",
        pre_induksi_konfirmasi: 0,
        pre_induksi_sisi_ditandai: 0,
        pre_induksi_file_penandaan: null,
        pre_induksi_cek_oxymetri: 0,
        pre_induksi_alergi: 0,
        pre_induksi_kesulitan_bernapas: 0,
        pre_induksi_resiko_darah: 0,
        pre_induksi_resiko_darah_ketersediaan: 0,
        time_out: "",
        pre_pembedahan_perkenalan: 0,
        pre_pembedahan_konfirmasi_nama_pasien: 0,
        pre_pembedahan_konfirmasi_prosedur: 0,
        pre_pembedahan_foto: 0,
        pre_pembedahan_antisipasi_prosedur_kritis: 0,
        pre_pembedahan_antisipasi_durasi: 0,
        pre_pembedahan_antisipasi_darah: 0,
        pre_pembedahan_anestesi_monitor: 0,
        pre_pembedahan_anestesi_monitor_keterangan: "",
        pre_pembedahan_perawat_instrumen: 0,
        pre_pembedahan_perawat_instrumen_khusus: 0,
        pre_pembedahan_perawat_instrumen_khusus_keterangan: "",
        pre_pembedahan_pencegahan_antibiotik: 0,
        pre_pembedahan_pencegahan_cukur_rambut: 0,
        pre_pembedahan_pencegahan_kontrol_gula: 0,
        sign_out: "",
        post_prosedur_dicatat: 0,
        post_kelengkapan_instrumen: 0,
        post_diberi_label: 0,
        post_masalah_peralatan: 0,
        post_masalah_peralatan_keterangan: "",
        post_perhatian_pasien: 0,
      },
      saveSuccess: false,
      saveFailed: false,
    };
  },
  methods: {
    save: async function() {
      this.handleForm();
    },
    continue: function() {
      this.$router.push(
        `/operasi/detail/${this.$route.params.id_ralan}/${this.$route.params.id}`
      );
    },
    cancel: function() {
      this.$router.push(
        `/operasi/detail/${this.$route.params.id_ralan}/${this.$route.params.id}`
      );
    },
    saveAndContinue: async function() {
      this.handleForm(this.continue);
    },
    handleForm: async function(callback) {
      this.errors = [];
      let formData = new FormData();
      let formData2 = new FormData();
      var self = this;
      ////console.log(this.formSet);
      let valid = this.validateForm();
      if (valid) {
        Object.keys(this.formSet).forEach(function(key) {
          ////console.log("==================formdata========");
          ////console.log(key);
          ////console.log(self.formSet[key]);
          ////console.log("==================formdata========");

          if (["sign_in", "time_out", "sign_out"].indexOf(key) > -1) {
            formData2.append(key, self.formSet[key]);
          } else {
            if (key == "pre_induksi_file_penandaan") {
              if (self.formSet[key]) {
                formData.append(key, self.formSet[key]);
              }
            } else {
              if (!self.formSet[key]) {
                if (
                  [
                    "pre_induksi_resiko_darah_ketersediaan",
                    "pre_pembedahan_anestesi_monitor_keterangan",
                    "pre_pembedahan_perawat_instrumen_khusus_keterangan",
                    "post_masalah_peralatan_keterangan",
                    "post_perhatian_pasien",
                  ].indexOf(key) > -1
                ) {
                  formData.append(key, "");
                } else {
                  formData.append(key, 0);
                }
              } else {
                formData.append(key, self.formSet[key]);
              }
            }
          }
        });
        try {
          let result;
          ////console.log('Id Laporan: '+this.id_ceklis);
          result = await this.$store.state.HTTP.post(
            "operasi/" + this.$route.params.id,
            formData2
          );
          ////console.log(result);
          if (this.id_ceklis) {
            result = await this.$store.state.HTTP.post(
              "operasi_keselamatan/" + this.id_ceklis,
              formData
            );
          } else {
            result = await this.$store.state.HTTP.post(
              "operasi_keselamatan",
              formData
            );
          }
          ////console.log(result);
          if (result.status == "200") {
            this.saveFailed = false;
            this.saveSuccess = true;
            var that = this;
            setTimeout(function() {
              that.saveSuccess = false;
              // that.$router.push(`/ralan/detail/${that.$route.params.id}`);
              if (callback) {
                callback();
              } else {
                that.$router.push(
                  `/operasi/form-ceklis/${that.$route.params.id_ralan}/${that.$route.params.id}`
                );
              }
            }, 1000);
          } else {
            ////console.log(result.status);
            this.errors.push(result.status);
            this.saveFailed = true;
          }
        } catch (e) {
          ////console.log(e);
          this.errors.push(e);
          this.saveFailed = true;
        }
      } else {
        ////console.log("tidak valid");
      }
    },
    handleChange(e) {
      if (e.target.type == "file") {
        if (e.target.files && e.target.files.length) {
          this.formSet[e.target.name] = e.target.files[0];
        }
      } else {
        ////console.log("====================onchange===========");
        ////console.log(e.target.name);
        ////console.log(e.target.value);
        ////console.log("====================onchange===========");
        this.formSet[e.target.name] = e.target.value;
      }
      ////console.log(this.formSet[e.target.name]);
    },

    validateForm: function() {
      let valid = true;
      let self = this;
      ////console.log(self.formSet);
      let forms = [
        this.upperForm,
        this.leftForm,
        this.middleForm,
        this.rightForm,
      ].map(function(form) {
        form = form.map(function(row) {
          row.columns = row.columns.map(function(column) {
            if (
              !column.optional &&
              column.type != "hidden" &&
              !self.formSet[column.name] &&
              self.formSet[column.name] != 0
            ) {
              valid = false;
              column.error = "Kolom ini wajib diisi";
            } else if (
              [
                "number",
                "money",
                "addon-right",
                "addon-left",
                "percentage",
              ].indexOf(column.type) > -1 &&
              !column.negativeValue &&
              parseInt(self.formSet[column.name]) < 0
            ) {
              column.error = "Nilai yang diisi tidak boleh negatif";
            } else {
              column.error = "";
            }
            if (self.formSet[column.name]) {
              if (column.type == "file") {
                var reader = new FileReader();
                reader.onload = function(e) {
                  column.value = e.target.result;
                };
                reader.readAsDataURL(self.formSet[column.name]);
              } else {
                column.value = self.formSet[column.name];
              }
            }
            return column;
          });
          return row;
        });
        return form;
      });
      this.upperForm = forms[0];
      this.leftForm = forms[1];
      this.middleForm = forms[2];
      this.rightForm = forms[3];
      return valid;
    },
    fetchData: async function() {
      let result = await this.$store.state.HTTP.get(
        `operasi_keselamatan?id_operasi=${this.$route.params.id}`
      );
      ////console.log(result);
      ////console.log(result.data);
      ////console.log(result.data.data);
      if (result.data.data.length) {
        this.id_ceklis = result.data.data[0].id;
        let self = this;
        let result2 = await this.$store.state.HTTP.get(
          `operasi_keselamatan/${this.id_ceklis}`
        );
        ////console.log(result2);
        this.operasiCeklis = result2.data;
        Object.keys(this.formSet).forEach(function(key) {
          if (["sign_in", "time_out", "sign_out"].indexOf(key) > -1) {
            self.formSet[key] = self.operasiCeklis.operasi[key];
          } else {
            if (key == "pre_induksi_file_penandaan") {
              self.formSet[key] = null;
              var url = getFullUrl(
                self.$store.state.baseStorageURL,
                self.operasiCeklis[key]
              );
              self.leftForm[3].columns[0].current_file_url = url;
            } else {
              if (self.operasiCeklis[key]) {
                self.formSet[key] = self.operasiCeklis[key];
              } else {
                if (
                  [
                    "pre_induksi_resiko_darah_ketersediaan",
                    "pre_pembedahan_anestesi_monitor_keterangan",
                    "pre_pembedahan_perawat_instrumen_khusus_keterangan",
                    "post_masalah_peralatan_keterangan",
                    "post_perhatian_pasien",
                  ].indexOf(key) > -1
                ) {
                  self.formSet[key] = "";
                }
              }
            }
          }
        });
        this.updateForm();
      }
    },
    updateForm() {
      let self = this;
      let forms = [
        this.upperForm,
        this.leftForm,
        this.middleForm,
        this.rightForm,
      ].map(function(form) {
        form = form.map(function(row) {
          row.columns = row.columns.map(function(column) {
            if (column.type == "file") {
              if (self.formSet[column.name]) {
                var reader = new FileReader();
                reader.onload = function(e) {
                  column.value = e.target.result;
                };
                reader.readAsDataURL(self.formSet[column.name]);
              }
            } else {
              column.value = self.formSet[column.name];
            }
            return column;
          });
          return row;
        });
        return form;
      });
      this.upperForm = forms[0];
      this.leftForm = forms[1];
      this.middleForm = forms[2];
      this.rightForm = forms[3];
    },
    fetchNurses: async function() {
      try {
        let result = await this.$store.state.HTTP.get(
          `petugas?per_page=9999999999`
        );
        if (result.status == "200") {
          this.upperForm[0].columns[0].options = result.data.data.map(
            (item) => {
              return { value: item.id, label: item.nama };
            }
          );
          if (!this.formSet.id_petugas) {
            this.formSet.id_petugas = this.$store.state.id_petugas || "";
            if (this.formSet.id_petugas) {
              this.upperForm[0].columns[0].value = this.formSet.id_petugas;
            }
          }
        } else {
          this.displayNotFoundError();
        }
      } catch (e) {
        ////console.log(e);
      }
    },
  },
  // created() {
  //   window.addEventListener(
  //     "hashchange",
  //     () => {
  //       // Do something when the hash changes
  //       location.reload();
  //     },
  //     false
  //   );
  // },
  mounted: async function() {
    this.empty.link +=
      this.$route.params.id_ralan + "/" + this.$route.params.id + "?fromTab=4";
    this.formSet["id_operasi"] = this.$route.params.id;
    await this.fetchData();
    await this.fetchNurses();
  },
};
</script>
